import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import validation from '../../../validation'
import TextArea from '../../controls/TextArea'

export default {
  name: 'Functional Status',
  group: 'Case Details',
  sectionNumber: 4,
  validationSchema: getValidationSchema(),
  Component,
}

function getValidationSchema() {
  return validation.object({
    cognition: validation.richText('Cognition'),
    communication: validation.richText('Communication'),
    psychological: validation.richText('Psychological / Behavior Issues'),
    adls: validation.richText('Activities of Daily living (ADLS)/ Self-care'),
    limitations: validation.richText('Limitations of Activities'),
    sleep: validation.richText('Sleep'),
    pain: validation.richText('Pain levels'),
    other: validation.richText('Other'),
  })
}

function Component({ caseModel, createInputProps, getValue, setModelValue, ErrorMessage }) {
  const rows = 4

  const renderField = (name, label, helpText) => (
    <div className="col-md-6">
      <div className="form-group">
        <label className="form-label mt-2" htmlFor={`functional.${name}`}>
          {label}{' '}
          {helpText && (
            <OverlayTrigger placement="right" overlay={<Tooltip id={`tooltip-${name}`}>{helpText}</Tooltip>}>
              <i
                className="fa fa-question-circle"
                style={{ fontSize: '0.9rem', cursor: 'pointer', color: '#2f5496', marginLeft: '5px' }}
              />
            </OverlayTrigger>
          )}
        </label>
        <TextArea
          areaProps={{ ...createInputProps(`functional.${name}`) }}
          rows={rows}
          maxLength={validation.maxLengths.richText}
        />
        <div style={{ display: 'inline' }}>
          <ErrorMessage name={`functional.${name}`} />
        </div>
      </div>
    </div>
  )

  return (
    <div>
      <h4 className="pb-3">Functional Status</h4>
      <div className="form-row">
        {renderField('cognition', 'Cognition', 'Deficits & Ability to process info in order to proceed in rehab')}
        {renderField('communication', 'Communication', 'Language deficits, language spoken')}
      </div>
      <div className="form-row">
        {renderField(
          'psychological',
          'Psychological / Behavior Issues',
          'Depression, anxiety, Aggressive, abusive, disinhibition, noncompliance, irritability, frustration, impulsivity, apathy, disruptive, lack of personal hygiene',
        )}
        {renderField(
          'adls',
          'Activities of Daily living (ADLS)/ Self-care',
          'Bathing, Dressing, cook/eating, Bowel/Bladder independence, transferring, grooming, laundry',
        )}
      </div>
      <div className="form-row">
        {renderField(
          'limitations',
          'Limitations of Activities due to injury/Level of Independence',
          'What are you unable to do now that you could do preinjury? What activities do you need assistance to complete ? (Stairs, walking distance, driving)',
        )}
        {renderField('sleep', 'Sleep', 'Number of hours, interrupted, sleeps in chair, awakens due to pain')}
      </div>
      <div className="form-row">
        {renderField('pain', 'Pain levels', '(0-10 scale) , which body part, activities that make better or worse')}
        {renderField('other', 'Other', null)}
      </div>
    </div>
  )
}
